import styled from 'styled-components'

import SectionWrapper from 'components/SectionWrapper'
import { setBackground } from 'utils/styled/setBackground'

export const Cover = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: center / cover no-repeat;
  ${({ image }) => setBackground('jpg', image, { xs: 640, md: 1280 })};
`

export const SectionWrapperStyled = styled(SectionWrapper)`
  .b-how-interpreting__inner {
    ${p => p.theme.mq.upMd} {
      min-height: ${p => p.theme.blocks.heightBlock560};
    }
  }
`
